import React from 'react';
import GradientWrapper from './GradientWrapper';
interface GradientIconCircleProps {
  children: ReactNode;
  size?: number;
  onClick?: () => void;
  className?: string;
}
const GradientIconCircle: React.FC<GradientIconCircleProps> = ({
  children,
  size = 32,
  onClick,
  className = ''
}) => {
  return <GradientWrapper radius="50%" paddingPx={1} data-id="element-1246">
      <div onClick={onClick} className={`bg-white flex items-center justify-center ${onClick ? 'cursor-pointer hover:bg-gray-50' : ''} transition-colors ${className}`} style={{
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%'
    }} data-id="element-1247">
        {children}
      </div>
    </GradientWrapper>;
};
export default GradientIconCircle;